export default function MissionController($scope, $state, DataService, MapService, MapDrawService, TitleService, NotificationService, utils) {
	"ngInject";

	const vm = this;

	vm.$onInit = () => {
		vm.loading = true;

		DataService.getMission().then((mission) => {
			TitleService.setTitleOrg(mission);

			vm.mission = mission;
			vm.assigned = DataService.getAssignedOrgs(vm.mission);
			vm.map = DataService.instantMap();
			vm.recenter();

			vm.loadMapOpts();

			vm.loading = false;
		}, NotificationService.exception(vm));

		DataService.getAllCustoms().then((customs) => {
			vm.customs = customs;
			vm.loadMapOpts();
		});
	};

	vm.recenter = () => {
		MapService.centerMap(vm.mission, vm.map);
	};

	vm.loadMapOpts = () => {
		let automaticOrgs = utils.cloneArray(vm.assigned).concat(vm.customs || []);
		DataService.setMapOpts({selectedOrg: vm.mission, automaticOrgs});
	};


	vm.addCustom = () => {
		$state.go("custom-create");
	};
}
